import { Sticky } from './Sticky.js';
import { bold, cyan, darkGrey } from './ansiHelpers.js';
import { getTimestamp } from './getTimestamp.js';

export const spinCharacters = ['⠋', '⠙', '⠸', '⠴', '⠦', '⠇'];

export class SpinningSticky extends Sticky {
  _intervalId: NodeJS.Timeout;
  _spinnerIndex = 0;

  constructor(text: string) {
    super(text);
    this.text = this._getMessageText(text);
    this._intervalId = setInterval(() => {
      this._spinnerIndex = (this._spinnerIndex + 1) % spinCharacters.length;
      this.update(this._getMessageText(text));
    }, 100);
  }

  remove(): void {
    clearInterval(this._intervalId);
    super.remove();
  }

  private _getMessageText(text: string): string {
    return `${darkGrey(`[${getTimestamp()}]`)} ${spinCharacters[this._spinnerIndex]} ${bold(cyan(text))}`;
  }
}
